export const REFRESH_ALL_DYNAMIC_FIELDS = "@ALL@";